module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.screenSize > 1),
      expression: "screenSize>1"
    }],
    staticClass: "settingsMenuContainer"
  }, [_c('div', {
    staticClass: "settingsMenuItemTitle"
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/name')) + "  ")]), _vm._v(" "), (_vm.$p('settings/interface')) ? _c('div', {
    class: _vm.getClass('interface'),
    on: {
      "click": function($event) {
        return _vm.navigate('interface')
      }
    }
  }, [_vm._v("  " + _vm._s(_vm.$l('settings/interface/settingsName')) + " "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/download')) ? _c('div', {
    class: _vm.getClass('download'),
    on: {
      "click": function($event) {
        return _vm.navigate('download')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/download/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/audioRecording')) ? _c('div', {
    class: _vm.getClass('audioRecording'),
    on: {
      "click": function($event) {
        return _vm.navigate('audioRecording')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/audioRecording/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/dynamicDns/enabled')) ? _c('div', {
    class: _vm.getClass('dynamicDns'),
    on: {
      "click": function($event) {
        return _vm.navigate('dynamicDns')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/dynamicDns/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/alertMessaging/enabled')) ? _c('div', {
    class: _vm.getClass('alertMessaging'),
    on: {
      "click": function($event) {
        return _vm.navigate('alertMessaging')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/FTPSending/enabled')) ? _c('div', {
    class: _vm.getClass('FTPSending'),
    on: {
      "click": function($event) {
        return _vm.navigate('FTPSending')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/FTPSending/settingsName')) + "  "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/geographicPosition')) ? _c('div', {
    class: _vm.getClass('geographicPosition'),
    on: {
      "click": function($event) {
        return _vm.navigate('geographicPosition')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/geographicPosition/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/weather') && _vm.getSettingsAddons.weather == '1') ? _c('div', {
    class: _vm.getClass('weather'),
    on: {
      "click": function($event) {
        return _vm.navigate('weather')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/weather/settingsName')) + "  "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/delete')) ? _c('div', {
    class: _vm.getClass('delete'),
    on: {
      "click": function($event) {
        return _vm.navigate('delete')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/delete/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/device') && _vm.getSettingsAddons.noise == '1') ? _c('div', {
    class: _vm.getClass('device'),
    on: {
      "click": function($event) {
        return _vm.navigate('device')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/device/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/video') && _vm.getSettingsAddons.video == '1') ? _c('div', {
    class: _vm.getClass('video'),
    on: {
      "click": function($event) {
        return _vm.navigate('video')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/video/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/adio') && _vm.getSettingsAddons.adio == '1') ? _c('div', {
    class: _vm.getClass('adio'),
    on: {
      "click": function($event) {
        return _vm.navigate('adio')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/adio/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/norcloud')) ? _c('div', {
    class: _vm.getClass('norcloud'),
    on: {
      "click": function($event) {
        return _vm.navigate('norcloud')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/norcloud/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.getClass('statistics'),
    on: {
      "click": function($event) {
        return _vm.navigate('statistics')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/statistics/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]), _vm._v(" "), (_vm.$p('settings/status/enabled')) ? _c('div', {
    class: _vm.getClass('status'),
    on: {
      "click": function($event) {
        return _vm.navigate('status')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/status/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "settings-menu-top-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.screenSize < 2),
      expression: "screenSize<2"
    }],
    staticClass: "settings-menu-top"
  }, [_c('div', {
    staticClass: "settingsMenuItemTitle settings-top-title",
    on: {
      "click": function($event) {
        _vm.menuVisible = !_vm.menuVisible
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/name')) + " \n                "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.menuVisible),
      expression: "!menuVisible"
    }],
    staticClass: "el-icon-arrow-right pull-right settings-menu-top-icon"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuVisible),
      expression: "menuVisible"
    }],
    staticClass: "el-icon-arrow-down pull-right settings-menu-top-icon"
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuVisible),
      expression: "menuVisible"
    }],
    staticClass: "settings-menu-top-real"
  }, [_c('div', {
    staticClass: "settings-menu-items"
  }, [(_vm.$p('settings/interface')) ? _c('div', {
    class: _vm.getClass('interface'),
    on: {
      "click": function($event) {
        return _vm.navigate('interface')
      }
    }
  }, [_vm._v("  " + _vm._s(_vm.$l('settings/interface/settingsName')) + "  "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/download')) ? _c('div', {
    class: _vm.getClass('download'),
    on: {
      "click": function($event) {
        return _vm.navigate('download')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/download/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/audioRecording')) ? _c('div', {
    class: _vm.getClass('audioRecording'),
    on: {
      "click": function($event) {
        return _vm.navigate('audioRecording')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/audioRecording/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/dynamicDns/enabled')) ? _c('div', {
    class: _vm.getClass('dynamicDns'),
    on: {
      "click": function($event) {
        return _vm.navigate('dynamicDns')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/dynamicDns/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/alertMessaging/enabled')) ? _c('div', {
    class: _vm.getClass('alertMessaging'),
    on: {
      "click": function($event) {
        return _vm.navigate('alertMessaging')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/FTPSending/enabled')) ? _c('div', {
    class: _vm.getClass('FTPSending'),
    on: {
      "click": function($event) {
        return _vm.navigate('FTPSending')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/FTPSending/settingsName')) + "  "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/geographicPosition')) ? _c('div', {
    class: _vm.getClass('geographicPosition'),
    on: {
      "click": function($event) {
        return _vm.navigate('geographicPosition')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/geographicPosition/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/weather')) ? _c('div', {
    class: _vm.getClass('weather'),
    on: {
      "click": function($event) {
        return _vm.navigate('weather')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/weather/settingsName')) + "  "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/delete')) ? _c('div', {
    class: _vm.getClass('delete'),
    on: {
      "click": function($event) {
        return _vm.navigate('delete')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/delete/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/device')) ? _c('div', {
    class: _vm.getClass('device'),
    on: {
      "click": function($event) {
        return _vm.navigate('device')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/device/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/video')) ? _c('div', {
    class: _vm.getClass('video'),
    on: {
      "click": function($event) {
        return _vm.navigate('video')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/video/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/adio')) ? _c('div', {
    class: _vm.getClass('adio'),
    on: {
      "click": function($event) {
        return _vm.navigate('adio')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/adio/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/norcloud')) ? _c('div', {
    class: _vm.getClass('norcloud'),
    on: {
      "click": function($event) {
        return _vm.navigate('norcloud')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/norcloud/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.getClass('statistics'),
    on: {
      "click": function($event) {
        return _vm.navigate('statistics')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/statistics/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]), _vm._v(" "), (_vm.$p('settings/status/enabled')) ? _c('div', {
    class: _vm.getClass('status'),
    on: {
      "click": function($event) {
        return _vm.navigate('status')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/status/settingsName')) + "   "), _c('span', {
    staticClass: "selectedArrow"
  })]) : _vm._e()])])])], 1)]), _vm._v(" "), _c('el-row', {
    staticClass: "save-button-container",
    class: {
      'sidebar-margin': this.screenSize > 1, 'save-margin-top': this.screenSize <= 1
    }
  }, [_c('el-button', {
    staticClass: "save-button",
    attrs: {
      "type": _vm.saving ? 'default' : 'primary',
      "icon": _vm.saving ? 'loading' : ''
    },
    on: {
      "click": _vm.saveClicked
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$l('settings/save')) + " ")])])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    class: _vm.containerClass
  }, [_c('keep-alive', [(_vm.loaded) ? _c('router-view') : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b085d2a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Settings.vue
// module id = 453
// module chunks = 1